// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__-zuC9","text":"SelectPayment_text__2vNWd","title":"SelectPayment_title__3UImb","btn":"SelectPayment_btn__1eHrk"};